import React from "react";
import { View } from "react-native";
import tickIcon from "@/assets/tick-mark.png";
import { checkboxStyles } from "./styles";
import { TposIcon } from "../Icons/TposIcon";

type CheckboxProps = {
  enabled: boolean;
};

const Checkbox = ({ enabled }: CheckboxProps): JSX.Element => {
  const styles = checkboxStyles(enabled);
  return (
    <View style={styles.container}>
      <View style={styles.checkContainer}>
        {enabled && <TposIcon icon={tickIcon} size={30} />}
      </View>
    </View>
  );
};

export default Checkbox;
